<template>
  <li
      class="nav-item"
      :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
        v-bind="linkProps"
        class="d-flex align-items-center"
    >
      <feather-icon
          v-if="item.icon_type == null || item.icon_type === 'feathericon'"
          :icon="item.icon || 'CircleIcon'"
          :class="item.iconClass || item.iconColor"/>
      <i v-else :class="[{ [item.icon]: true }, item.iconClass || item.iconColor]"/>

      <span class="menu-title text-truncate" :class="item.textColor || item.titleClass">  {{ msg(item.title) }}</span>
      <b-badge
          v-if="hasTag"
          pill
          :variant="item.tagVariant || 'primary'"
          class="mr-1 ml-auto"
      >
        {{ tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
// import { ref } from '@vue/composition-api'
import {BLink, BBadge} from 'bootstrap-vue'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasTag() {
      if (this.item.tag == null || this.$store.getters[this.item.tag] == null) {
        return false
      }
      let value = this.$store.getters[this.item.tag];
      if (!isNaN(value) && value <= 0) {
        return false
      }
      return true
    },
    tag() {
      console.log("Getting tag for item: ", this.item)
      return this.$store.getters[this.item.tag]
    }
  },
  setup(props) {
    const {isActive, linkProps, updateIsActive} = useVerticalNavMenuLink(props.item)

    return {
      isActive,
      linkProps,
      updateIsActive,
    }
  },

}
</script>
<style scoped>
.whatsappColor {
  color: rgb(37, 211, 102) !important;
}
</style>
